<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
		</b-breadcrumb>
		<b-container fluid>
		</b-container>
	</div>
</template>
<script>

export default {
  name: 'home',
  data: () => ({
  }),
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// HomePage.vue?f86feb50